var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrediction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 1.5625C3.28125 1.5625 1.3125 3.53125 1.3125 5.9375C1.3125 8.34375 3.28125 10.3125 5.6875 10.3125C8.12109 10.3125 10.0625 8.34375 10.0625 5.9375C10.0625 3.53125 8.12109 1.5625 5.6875 1.5625ZM5.6875 11.625C2.54297 11.625 0 9.08203 0 5.9375C0 2.79297 2.54297 0.25 5.6875 0.25C8.83203 0.25 11.375 2.79297 11.375 5.9375C11.375 7.27734 10.9375 8.50781 10.1445 9.46484L13.8086 13.1289L14.2734 13.5938L13.3438 14.5234L12.8789 14.0586L9.24219 10.3945C8.25781 11.1602 7.02734 11.625 5.6875 11.625ZM2.84375 6.15625V5.5H4.15625V8.125H2.84375V6.15625ZM5.03125 3.53125V2.875H6.34375V8.125H5.03125V3.53125ZM7.21875 5.28125V4.625H8.53125V8.125H7.21875V5.28125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrediction);
export default __webpack_public_path__ + "static/media/prediction.dcef752c02ab6da8ea0497408e6a73fc.svg";
export { ForwardRef as ReactComponent };